import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { SgDateUtil, SgSptTripUtils, SgSubmissionUtil } from 'saga-modules';
import SgProductService from 'sg-product-service';
import CommonConstants from 'sg-common-constants';
import _ from 'lodash';

const MOTOR_CODE = '39461';
const HOME_CODE = '39460';
const MOTORHOME_CODE = '39474';
const PMI_CODE = '39467';
const TRAVEL_SINGLE_CODE = '39475';
const TRAVEL_ANNUAL_CODE = '39476';

const getCodeNameByProduct = (modelVM) => {
    const product = SgProductService.getProduct();
    switch (product) {
        case CommonConstants.MOTOR_PRODUCT_DISPLAY.toLowerCase(): {
            return MOTOR_CODE;
        }
        case CommonConstants.HOME_PRODUCT_DISPLAY.toLowerCase(): {
            return HOME_CODE;
        }
        case CommonConstants.MOTORHOME_PRODUCT_CODE: {
            return MOTORHOME_CODE;
        }
        case CommonConstants.PMI_PRODUCT_CODE: {
            return PMI_CODE;
        }
        case CommonConstants.TRAVEL_PRODUCT_CODE_SPT: {
            const isSelectedTripSingle = SgSptTripUtils.isSelectedTripSingle(modelVM);
            if (isSelectedTripSingle) {
                return TRAVEL_SINGLE_CODE;
            }
            return TRAVEL_ANNUAL_CODE;
        }
        default:
            return '';
    }
};

const reqData = (modelVM) => {
    const codeName = getCodeNameByProduct(modelVM);
    const prodType = 'INS';
    const accountHolder = SgSubmissionUtil.getAccountHolder(modelVM);
    const gender = accountHolder.gender.value && accountHolder.gender.value.code;
    const annualPremium = SgSubmissionUtil.getAnnualPremium(modelVM);
    const fullDate = SgDateUtil.toStringShort(accountHolder.dateOfBirth.value);
    const csdFullDate = SgDateUtil.toStringShort(modelVM.baseData.periodStartDate.value);

    const currentDate = new Date();
    const datetime = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)}-${currentDate.getDate()}`;

    const mySagaAccount = {
        account: {
            emailAddress: accountHolder.emailAddress1.value,
            customer: {
                title: accountHolder.prefix.value && accountHolder.prefix.value.code,
                forename: accountHolder.firstName.value,
                surname: accountHolder.lastName.value,
                dateOfBirth: fullDate,
                telephoneNumber: accountHolder.homeNumber.value,
                address: {
                    addressLine1: accountHolder.primaryAddress.addressLine1.value,
                    addressLine2: accountHolder.primaryAddress.addressLine2.value,
                    city: accountHolder.primaryAddress.city.value,
                    county: accountHolder.primaryAddress.county.value,
                    postCode: accountHolder.primaryAddress.postalCode.value,
                },
                gender: gender === 'M' ? 'Male' : 'Female',
            }
        },
        ClientId: 'Insurance'
    };

    const mySagaProduct = {
        Product: {
            Name: codeName,
            ProductReference: `${modelVM.quoteID.value}~`,
            StartDate: csdFullDate,
            DaysValid: 0,
            IsPurchased: false,
            Price: annualPremium,
            IsVerified: false,
            SourceLastUpdated: datetime,
            Group: prodType,
        },
        EmailAddress: accountHolder.emailAddress1.value
    };

    return { mySagaProduct, mySagaAccount };
};

export default class SgMySagaService {
    static retrieveByGuid(actionGUID) {
        return JsonRPCService.send(getProxiedServiceUrl('mySagaService'), 'retrieveQuote', [actionGUID], {});
    }

    static retrieveByPolicyNumber(policyNumber) {
        return JsonRPCService.send(getProxiedServiceUrl('mySagaService'), 'retrieveDetailsWithPolicyNumber', [policyNumber], {});
    }

    static checkAndCallMySaga(modelVM, updateData) {
        // Call service once per journey
        if (modelVM.baseData.mySagaServiceCalled === undefined) {
            const data = reqData(modelVM);

            JsonRPCService.send(
                getProxiedServiceUrl('mySagaService'),
                'submitMySagaProductRequest',
                [JSON.stringify(data.mySagaAccount), JSON.stringify(data.mySagaProduct)],
                null
            ).then(() => {
                const newModelVM = _.clone(modelVM);
                _.set(newModelVM, 'baseData.mySagaServiceCalled', true);
                updateData(newModelVM);
            }).catch(() => {
                // do nothing on fail
            });
        }
    }
}
